module.exports = __webpack_public_path__ + "static/media/undercover1.bd879877.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/proj/undercover1.png
// module id = 175
// module chunks = 0